// extracted by mini-css-extract-plugin
module.exports = {"AboutMain":"About_AboutMain__1_EN2","AboutSec":"About_AboutSec__3tL0E","Intrest":"About_Intrest__u0_Hj","Description":"About_Description__3eMsd"};